import { useEffect, useState } from "react";
import { useCreateStripeAdminAxiosInstance } from "../../Auth/useCreateStripeAdminAxiosInstance.ts";
import { MoneyDTO } from "../../ProductService/NormasTeachingProduct/useNormasTeachingProductById.ts";

export type StripeRefundRecord = {
  _id: string;
  amountInCent: MoneyDTO;
  totalRefund: boolean;
  createdAt: string;
};

export function useGetStripeRefundRecord(orderId: string | null) {
  const { createAxiosInstance } = useCreateStripeAdminAxiosInstance();
  const [refund, setRefund] = useState<StripeRefundRecord | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!orderId) return;
    setLoading(true);
    createAxiosInstance()
      .get<{ refund: StripeRefundRecord | null }>(
        `/admin/refund/${orderId}/record`,
      )
      .then(({ data }) => setRefund(data.refund))
      .catch(() => setRefund(null))
      .finally(() => setLoading(false));
  }, [orderId]);

  return { refund, loading };
}
